var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 8,
    viewBox: "0 0 19 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m 1.25,1.75 h 16.5 c 0.1989,0 0.3897,-0.07902 0.5303,-0.21967 C 18.421,1.38968 18.5,1.19891 18.5,1 18.5,0.801088 18.421,0.610322 18.2803,0.46967 18.1397,0.329018 17.9489,0.25 17.75,0.25 H 1.25 C 1.05109,0.25 0.860322,0.329018 0.71967,0.46967 0.579018,0.610322 0.5,0.801088 0.5,1 0.5,1.19891 0.579018,1.38968 0.71967,1.53033 0.860322,1.67098 1.05109,1.75 1.25,1.75 Z",
    fill: "#FFFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m 14.970433,6.9183611 c 0,0.19891 -0.06351,0.38968 -0.176619,0.53033 -0.11303,0.14065 -0.266417,0.21967 -0.426316,0.21967 H 1.1029347 c -0.15990633,0 -0.3132672,-0.07902 -0.42633914,-0.21967 C 0.5635236,7.3080411 0.5,7.1172711 0.5,6.9183611 c 0,-0.19891 0.0635236,-0.38968 0.17659556,-0.53033 0.11307194,-0.14065 0.26643281,-0.21967 0.42633914,-0.21967 H 14.367498 c 0.159899,0 0.313286,0.07902 0.426316,0.21967 0.11311,0.14065 0.176619,0.33142 0.176619,0.53033 z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.ac289b20f9718442e3013c5dd239264d.svg";
export { ForwardRef as ReactComponent };